import type { OrderItem } from '@/flight-deck-api/services/order-items.service'

export const hasSpendError = (orderItem: OrderItem): boolean =>
  orderItem.campaignGroups.some(campaign => campaign.hasSpendError)
